import {
  getPredictionCategoryTab,
  PREDICTION_CATEGORY_OTHER,
  resolvePredictionEventSeries,
  type IPredictionOutcomeEvent,
  type IPredictionOutcomeEventSeriesRecord,
} from '@talos/kyoko';

export { getPredictionCategoryTab, PREDICTION_CATEGORY_OTHER, resolvePredictionEventSeries };

export function filterPredictionEventsBySeries(
  events: IPredictionOutcomeEvent[],
  series: IPredictionOutcomeEventSeriesRecord | undefined
): IPredictionOutcomeEvent[] {
  if (!series) {
    return events;
  }
  return events.filter(event => event.SeriesID != null && event.SeriesID === series.SeriesID);
}
